import { RecordType } from '@xbcb/shared-types';

// Direct mapping from work order type to category list
const WORK_ORDER_CATEGORY_MAPPING: Partial<Record<RecordType, string[]>> = {
  [RecordType.IMPORTER_ENTITY_ACTIVATION]: [
    '9f932241-a1c6-47f0-a84d-21bc1ceb60eb',
    'd8f98f3c-d04a-431f-ad2f-04427ea8ecf1',
  ],
  [RecordType.US_CONSUMPTION_ENTRY]: [
    '98895758-0335-43dd-a5e4-60f3baa11de3',
    'fac97f14-9a61-482d-9f32-3957b7b97312',
    '90c8f987-5407-461b-b03b-5e2e5e252c79',
    '6c73c237-089f-4f1c-8b45-2484a0a458a4',
    'a4b644ad-1e09-416e-8cf5-08334f634f2d',
    '68d445af-6a39-41d0-b615-dfe6f64fe9a3',
    'a3a04175-c72f-452e-bcaa-0d62fc277f70',
    '89531153-4c1d-442e-bed2-d53ca3beda08',
    '7855b051-bd33-4307-aff2-9671c943bd25',
    '71b80750-0192-442f-9efb-6e85f3779cc3',
    '8a2732ea-4ee3-4e9d-b10e-808a3b5a3284',
    '775c907d-666a-48cf-80b5-9ac4341e991c',
    '691e745b-6a98-4229-9e08-59d09e322883',
    'e6fd791e-fd32-4001-80d3-68094174a771',
    'd8f98f3c-d04a-431f-ad2f-04427ea8ecf1',
    'ae765dc2-9bc9-4275-a11c-dea7fad22625',
    '3439ab10-9a01-4f54-8958-6b7bd71d9062',
    '03991266-b093-4741-8d93-d7a428c25539',
  ],
  [RecordType.US_POST_SUMMARY_CORRECTION]: [
    '98895758-0335-43dd-a5e4-60f3baa11de3',
    '90c8f987-5407-461b-b03b-5e2e5e252c79',
    '6c73c237-089f-4f1c-8b45-2484a0a458a4',
    'a4b644ad-1e09-416e-8cf5-08334f634f2d',
    '68d445af-6a39-41d0-b615-dfe6f64fe9a3',
    'a3a04175-c72f-452e-bcaa-0d62fc277f70',
    '89531153-4c1d-442e-bed2-d53ca3beda08',
    '7855b051-bd33-4307-aff2-9671c943bd25',
    '71b80750-0192-442f-9efb-6e85f3779cc3',
    '8a2732ea-4ee3-4e9d-b10e-808a3b5a3284',
    '775c907d-666a-48cf-80b5-9ac4341e991c',
    '691e745b-6a98-4229-9e08-59d09e322883',
    'e6fd791e-fd32-4001-80d3-68094174a771',
    'd8f98f3c-d04a-431f-ad2f-04427ea8ecf1',
    'ae765dc2-9bc9-4275-a11c-dea7fad22625',
    '3439ab10-9a01-4f54-8958-6b7bd71d9062',
  ],
  [RecordType.US_ISF]: [
    '98895758-0335-43dd-a5e4-60f3baa11de3',
    '90c8f987-5407-461b-b03b-5e2e5e252c79',
    '6c73c237-089f-4f1c-8b45-2484a0a458a4',
    'a4b644ad-1e09-416e-8cf5-08334f634f2d',
    '68d445af-6a39-41d0-b615-dfe6f64fe9a3',
    'a3a04175-c72f-452e-bcaa-0d62fc277f70',
    '89531153-4c1d-442e-bed2-d53ca3beda08',
    '7855b051-bd33-4307-aff2-9671c943bd25',
    '71b80750-0192-442f-9efb-6e85f3779cc3',
    '8a2732ea-4ee3-4e9d-b10e-808a3b5a3284',
    '775c907d-666a-48cf-80b5-9ac4341e991c',
    '691e745b-6a98-4229-9e08-59d09e322883',
    'e6fd791e-fd32-4001-80d3-68094174a771',
    'd8f98f3c-d04a-431f-ad2f-04427ea8ecf1',
    'ae765dc2-9bc9-4275-a11c-dea7fad22625',
    '3439ab10-9a01-4f54-8958-6b7bd71d9062',
  ],
};

export const getCategoryListForWorkOrder = (
  recordType: RecordType,
): string[] => {
  return WORK_ORDER_CATEGORY_MAPPING[recordType] || [];
};
